<template lang="pug">
v-dialog(v-model="value" persistent :width="width")
  v-card(:class="{'rounded': rounded}")
    .close-btn-container.mr-2(v-if="closeButton")
      v-btn.icon-btn.ma-0.pa-0(flat icon @click="$emit('click:close')")
        v-icon.ma-0.pa-0(size="20") {{ closeButtonIcon }}
    v-layout.dialog-container(column wrap)
      v-flex.pb-4(v-if="dialogTitle" xs12)
        div.title {{ dialogTitle }}
      v-flex.pb-4(v-if="dialogSubtitle" xs12)
        div.subtitle {{ dialogSubtitle }}
      v-flex.pb-4(v-if="dialogBody && isHTML(dialogBody)" v-html="dialogBody" xs12)
      v-flex.pb-4(v-else-if="dialogBody" xs12)
        div {{ dialogBody }}
      v-flex.pb-4(v-if="$slots.body" xs12)
        slot(name="body")

      v-flex(v-if="!hideOkButton" xs12)
        v-btn.primary(:disabled="disableOkButton" @click="$emit('click:ok')" data-cy="submit-button") {{ okButtonText }}
      v-flex(v-if="!hideCancelButton" xs12)
        v-btn(flat @click="$emit('click:cancel')" color='primary') {{ cancelButtonText }}
        
</template>

<script>
import { isHTML } from '@/Core/utilities/parser-string';

export default {
  name: 'liondesk-dialog-v2',
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogSubtitle: {
      type: String,
      default: '',
    },
    dialogBody: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'Ok',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
    value: {
      type: Boolean,
    },
    hideCancelButton: {
      type: Boolean,
      default: false,
    },
    hideOkButton: {
      type: Boolean,
      default: false,
    },
    disableOkButton: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '560px',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: false,
    },
    closeButtonIcon: {
      type: String,
      default: 'close'
    },
  },
  methods: {
    isHTML
  }
};
</script>

<style scoped lang="scss">
.dialog-container {
  justify-content: center;
  text-align: center;
  padding: 30px;
}

.title {
  font-size: 24px !important;
  color: var(--v-primary-base);
  font-weight: 300;
}

.subtitle {
  font-weight: bold;
}

.rounded {
  border-radius: 10px;
}

.close-btn-container {
  position: absolute;
  right: 0;
}
</style>
